import styled from 'styled-components';

export const Main = styled.footer`
  position: fixed;        /* fixa na tela */
  bottom: 0;
  left: 0;
  width: 100vw;           /* sempre ocupa a largura total */
  height: 40px;

  display: flex;
  align-items: center;    /* centraliza verticalmente */
  justify-content: center;/* centraliza horizontalmente */

  background-color: var(--vo-mist);
  box-shadow: 0px -2px 6px rgba(0,0,0,0.08);

  span {
    color: var(--color-brand);
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
  }

  p {
    color: var(--vo-ink);
    font-size: 12px;
    line-height: 16px;
    margin: 0 0 0 4px;
  }
`;
